import { render, staticRenderFns } from "./promotionalGifts.vue?vue&type=template&id=6d4cac40&scoped=true&"
import script from "./promotionalGifts.vue?vue&type=script&lang=js&"
export * from "./promotionalGifts.vue?vue&type=script&lang=js&"
import style0 from "./promotionalGifts.vue?vue&type=style&index=0&id=6d4cac40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4cac40",
  null
  
)

export default component.exports